import React, { useContext, useEffect } from 'react'
import { GMCContext } from '../../GMCContext';
import axios from 'axios';
import Copy from '../Common/Copy';
import { useState } from 'react';
import Pagination from '../Common/Pagination';


export default function WithdrawalReport({ username }) {
  const { togel, formatAddress, setTogel, isSidebarEnabled, setIsSidebarEnabled, formatDateTime } = useContext(GMCContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");


  // Fetch data function
  const getData = async () => {
    try {
      setLoading(true);
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "withdrawal",
        submethod: "getbyid",
        key: process.env.REACT_APP_KEY,
        username,
        search: search,
        page: currentPage,
        pageSize: pageSize,

      });

      setLoading(false);
      if (res.data.error) return;
      // console.log('res.data.data111', res.data.data)
      setData(res.data.data);
      setPages(Math.ceil(res.data.total / pageSize));
    } catch (err) {
      console.log("Error : ", err);
      setLoading(false);
    }
  };

  // console.log("data:", data)
  useEffect(() => {
    if (username) {
      getData();
    }
  }, [username, pages, pageSize, currentPage]);

  useEffect(() => {
    if (search) {
      setCurrentPage(1);
    }
    getData();
  }, [pageSize, currentPage, search,]);

  return (
    <>
      {/* Member Report Table Section */}
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title mb-0">Withdrawal</h4>
            </div>
            <div className="card-body">
              <div className="listjs-table" id="customerList">
                {/* Table Action Buttons */}
                <div className="row g-4 mb-3">
                  <div className="col-sm-auto">

                  </div>
                  <div className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      <div className="search-box ms-2">
                        <input
                          type="text"
                          className="form-control search"
                          placeholder="Search..."
                          onChange={(e) => setSearch(e.target.value)}
                        />
                        <i className="ri-search-line search-icon" />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Table */}
                <div className="table-responsive table-card mt-3 mb-1">
                  <table className="table align-middle table-nowrap" id="customerTable">
                    <thead className="table-light">
                      <tr>
                        <th className="gridjs-th text-center">#</th>
                        <th className="gridjs-th text-center">Hash</th>
                        <th className="gridjs-th text-center">Amount</th>
                        <th className="gridjs-th text-center">Fee</th>
                        <th className="gridjs-th text-center">Rate</th>
                        <th className="gridjs-th text-center">Total Receive</th>
                        <th className="gridjs-th text-center">Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.length > 0 ? (
                        data.map((ele, i) => {
                          const index = currentPage * pageSize - pageSize + (i + 1);
                          return (
                            <tr key={i}>
                              <td className="gridjs-td text-center">{index}</td>
                              <td className="gridjs-td text-center">
                                <a
                                  target="_blank"
                                  className="text-primary"
                                  href={`${process.env.REACT_APP_EXPLORER}/address/${ele.hash}`}
                                  rel="noreferrer"
                                >
                                  {formatAddress(ele.hash)}
                                </a>
                                <Copy data={ele.hash} />
                              </td>
                              <td className="gridjs-td text-center">$ {ele.amount || "0"}</td>
                              <td className="gridjs-td text-center">{parseFloat(ele.fee).toFixed(2)} ({(ele.fee_per || "0")}%)</td>
                              <td className="gridjs-td text-center">$ {ele.rate || "0"}</td>
                              <td className="gridjs-td text-center">$ {ele.totalrcv || "0"}</td>
                              <td className="gridjs-td text-center">{formatDateTime(ele.createdAt)}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="11" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <Pagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  pages={pages}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
